import React, { FC, useRef, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { NavLink } from "react-router";

import { Box, Button, Divider, Icon, Modal } from "../ui";
import { IconName } from "../ui/icons/icons.type";
import useWindowSize from "../../hooks/use-window-size";
import { Item } from "../../models/item.type";
import { pages } from "../../utils/routrer-utils";
import { FeedbackForm } from "../index";
import Rating from "../rating";
import { Package } from "../../models/package.type";
import { useUpdatePackageMutation } from "../../store/api/package.api";

import File from "./file";
import BoxPreview from "./box-preview";
import styles from "./index.module.css";

type ChevronPositions = "left" | "right";

type FilePreviewProps = {
  files: Array<Item>;
  pack: Package;
};

const FilePreview: FC<FilePreviewProps> = (props) => {
  let { files, pack } = props;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [openFeedBack, setOpenFeedBack] = useState(false);
  const [currentRating, setCurrentRating] = useState(pack.rating);
  const sliderRef = useRef<Slider | null>(null);
  const { width } = useWindowSize();
  const [changeRating] = useUpdatePackageMutation();
  files = files.filter((file) => file.type !== 5);

  const settings = {
    dots: false,
    speed: 500,
    slidesToScroll: 1,
    autoplay: false,
    infinite: files.length > 3,
  };

  const renderButtonAllContent = (
    <NavLink to={`${pages.FILES}/${pack.id}`}>
      <Button
        width={150}
        padding={25}
        label="Просмотреть весь медиапакет"
        variant="fill"
      />
    </NavLink>
  );

  const handleChangeRatingAndOpenFeedBack = async (rating: number) => {
    await changeRating({ id: pack.id, rating }).unwrap();
    setCurrentRating(rating);
    setOpenFeedBack(true);
  };

  const handleChangeSlide = (position: ChevronPositions) => {
    if (position === "left") {
      sliderRef?.current.slickPrev();
      currentIndex > 0
        ? setCurrentIndex(currentIndex - 1)
        : setCurrentIndex(files.length - 1);
    }
    if (position === "right") {
      sliderRef?.current.slickNext();
      currentIndex < files.length - 1
        ? setCurrentIndex(currentIndex + 1)
        : setCurrentIndex(0);
    }
  };

  const renderIconNavigation = (position: ChevronPositions) => {
    const iconType: Record<ChevronPositions, IconName> = {
      left: "ChevronLeft",
      right: "ChevronRight",
    };

    return (
      <div
        className={styles.navigationIcon}
        onClick={() => handleChangeSlide(position)}
      >
        <Icon name={iconType[position]} size={10} />
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <Box className={styles.boxContainer}>
        <BoxPreview file={files[currentIndex].file_link} />
        <div className={styles.sliderContainer}>
          <div className={styles.leftArrowMobile}>
            {sliderRef !== null && renderIconNavigation("left")}
          </div>
          <div className={styles.sliderWrapper}>
            <Slider
              ref={sliderRef}
              {...{
                ...settings,
                slidesToShow: width > 1024 ? 5 : width > 615 ? 4 : 3,
              }}
            >
              {files.map((file, index) => (
                <File
                  key={file.id}
                  file={file}
                  isSelect={files[currentIndex].id === file.id}
                  onClick={setCurrentIndex.bind(null, index)}
                />
              ))}
            </Slider>
          </div>
          <div className={styles.rightArrowMobile}>
            {sliderRef !== null && renderIconNavigation("right")}
          </div>
        </div>
        <Divider />
        <div className={styles.controlsContainer}>
          <div className={styles.ratingContainer}>
            <div className={styles.ratingWrapper}>
              <div onClick={setOpenFeedBack.bind(null, true)}>
                <Rating
                  ratingCount={currentRating}
                  onRatingChange={handleChangeRatingAndOpenFeedBack}
                />
              </div>
            </div>
          </div>
          <div className={styles.downloadButtonContainerTablet}>
            {renderButtonAllContent}
          </div>
          <div className={styles.questionButtonContainer}>
            <NavLink to={pages.HELP}>
              <Button
                size="large"
                padding={23}
                label="Вопросы по видео?"
                variant="outlined"
              />
            </NavLink>
          </div>
          <div className={styles.downloadButtonContainerMobile}>
            {renderButtonAllContent}
          </div>
        </div>
        <div className={styles.leftArrowDesktop}>
          {sliderRef !== null && renderIconNavigation("left")}
        </div>
        <div className={styles.rightArrowDesktop}>
          {sliderRef && renderIconNavigation("right")}
        </div>
      </Box>
      <Modal isShow={openFeedBack} onShow={setOpenFeedBack}>
        <Box className={styles.feedbackModal}>
          <FeedbackForm title="Оставить отзыв" package_id={pack.id} />
        </Box>
      </Modal>
    </div>
  );
};

export default FilePreview;
